import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var StaffService = (function () {
    function StaffService($http) {
        this.$http = $http;
    }
    StaffService.prototype.getPhotos = function (take, dimensions) {
        if (take === void 0) { take = 1; }
        if (dimensions === void 0) { dimensions = 100; }
        return this.$http
            .get("/support/api/staff/photos?take=" + take + "&dimensions=" + dimensions)
            .then(function (response) { return response.data || []; });
    };
    StaffService.$inject = ['$http'];
    StaffService = __decorate([
        Injectable('staff'),
        __param(0, Inject('$http')),
        __metadata("design:paramtypes", [Function])
    ], StaffService);
    return StaffService;
}());
export { StaffService };
